import { formatCurrencyForDisplay } from '@utils'
import { useCurrencies } from 'mmfintech-backend-api'
import type { ReactNode } from 'react'

import styles from './FxRateRow.module.scss'

type MainAmountRowProps = {
  label?: ReactNode
  currency: string
  fxRate: number
  fxRateCurrency: string
  'data-test'?: string
}

const FxRateRow = (props: MainAmountRowProps) => {
  const { label, currency, fxRate, fxRateCurrency, 'data-test': dataTest } = props

  const { formatFxRate } = useCurrencies()

  return fxRate && currency !== fxRateCurrency ? (
    <div className={styles['fx-rate-preview-wrapper']} data-test={dataTest}>
      <span className='fx-rate-preview-label'>{label}:</span>
      <span className='fx-rate-content'>
        {'1 '}
        <span className='fx-rate-preview-currency'>{formatCurrencyForDisplay(currency)}</span>
        {' = '}
        {formatFxRate(fxRate, fxRateCurrency)}{' '}
        <span className='fx-rate-preview-currency'>{formatCurrencyForDisplay(fxRateCurrency)}</span>
      </span>
    </div>
  ) : null
}

export default FxRateRow
